import React from "react";
import { Accordion, Container } from "react-bootstrap";
import { FaChevronDown } from "react-icons/fa";
import "./TransportAccordion.css";
import { useTranslation } from "react-i18next";

const data = [
  {
    titleKey: "transportTabs.items.0.title",
    contentKey: "transportTabs.items.0.content",
  },
  {
    titleKey: "transportTabs.items.1.title",
    contentKey: "transportTabs.items.1.content",
  },
  {
    titleKey: "transportTabs.items.2.title",
    contentKey: "transportTabs.items.2.content",
  },
  {
    titleKey: "transportTabs.items.3.title",
    contentKey: "transportTabs.items.3.content",
  },
];

export default function TransportAccordion() {
  const { t } = useTranslation();

  return (
    <section className="py-5 bg-light">
      <Container fluid className="px-4 px-md-5">
        <h2 className="text-center text-orange fw-bold mb-4">
          {t("transportTabs.mainTitle")}
        </h2>
        <Accordion defaultActiveKey="">
          {data.map((item, index) => (
            <Accordion.Item
              eventKey={index.toString()}
              key={index}
              className="mb-3"
            >
              <Accordion.Header>
                <div className="d-flex justify-content-between align-items-center w-100">
                  <h5 className="title-accordion">{t(item.titleKey)}</h5>
                  <FaChevronDown className="accordion-icon ms-2" />
                </div>
              </Accordion.Header>
              <Accordion.Body style={{ fontSize: "1rem", lineHeight: "1.7" }}>
                {t(item.contentKey)}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Container>
    </section>
  );
}